import { SkeletonLoaderModule } from 'src/app/shared/skeleton-loader/skeleton-loader.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { AssessmentsManagementComponent } from './assessments-management.component';
import { TooltipModule } from 'ngx-bootstrap';
import { FormsModule } from '@angular/forms';
import { AssessmentsActionsModalComponent } from './assessments-actions-modal/assessments-actions-modal.component';
import { EntityActivitiesModule } from 'src/app/shared/entity-activities/entity-activities.module';
import { DeleteAssessmentCredentialModule } from './delete-assessment-credential/delete-assessment-credential.module';

const states: Ng2StateDeclaration[] = [
  {
    name: 'missioncontrol.assessmentManagement',
    url: '/assessmentManagement',
    component: AssessmentsManagementComponent,
    data: {
      requireLogin: true
    },
    params: {
      jobId: null,
      jobTitle: null,
      jobClient: null
    }
  }
];

@NgModule({
  declarations: [AssessmentsManagementComponent, AssessmentsActionsModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    SkeletonLoaderModule,
    TooltipModule,
    EntityActivitiesModule,
    DeleteAssessmentCredentialModule,
    UIRouterModule.forChild({ states })
  ],
  exports: [AssessmentsManagementComponent, AssessmentsActionsModalComponent],
  entryComponents: [AssessmentsManagementComponent, AssessmentsActionsModalComponent]
})
export class AssessmentsManagementModule { }
